module.exports = __webpack_public_path__ + "static/media/ohsikpark-logo.9b84e6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ohsikpark-logo.png
// module id = 47
// module chunks = 0